import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import validate from "common/validator";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { combineReducers, compose } from "redux";
import { getItemFromStorage } from "services/storage";
import injectReducer from "utils/injectReducer";
import InputTextField from "../../../components/StyleGuideComponents/InputTextField";
import Password from "../../../components/StyleGuideComponents/Password";
import PrimaryButton from "../../../components/StyleGuideComponents/PrimaryButton";
import { generateOtp, verifyOtp } from "../action";
import "../patientRegister.scss";
import { setOtpInState } from "../action";

import { signInUser } from "common/authThunkActions";
import Strings from "../../../strings";

import {
  FORGOT_PASSWORD_VIEW,
  LOGGED_IN_USER_PROCEDURE_VIEW,
  LOGIN_VIEW,
} from "../constants";

class LoginView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flowId: props.flowId || null,
      flowType: props.flowType || "sign_up",
      firstName: props.firstName || "",
      emailOtp: props.emailOtp || "",
      email: props.email || "",
      errors: [],
      phone: props.phone || "",
      zipCode: props.zipCode || "",
      emailOrMobileNumber: "",
      password: "",
      isSignedIn: props.isSignedIn,
      page: LOGIN_VIEW,
      showLoginHelpModal: false,
    };
  }

  phoneRule = [
    { rule: "isPhone", message: "Mobile Number or Email is invalid" },
    { rule: "isRequired", message: "Mobile Number or Email is required" },
  ];

  emailRule = [
    { rule: "isEmail", message: "Mobile Number or Email is invalid" },
    { rule: "isRequired", message: "Mobile Number or Email is required" },
  ];

  validationConfig = {
    fields: ["emailOrMobileNumber", "password"],
    rules: {
      emailOrMobileNumber: [
        { rule: "isEmail", message: "Mobile Number or Email is invalid" },
        { rule: "isRequired", message: "Mobile Number or Email is required" },
      ],
      password: [{ rule: "isRequired", message: "Password is required" }],
    },
  };

  handleChange = (name, value) => {
    let errors = this.state.errors;
    delete errors[name];

    this.setState({ [name]: value, errors: errors }, () => {});
  };

  onSubmitClick = () => {
    const { emailOrMobileNumber, password, otp } = this.state;
    const params = {
      password,
      code: otp,
    };
    if (emailOrMobileNumber.includes("@")) {
      params.email = emailOrMobileNumber;
    } else {
      const contactNumber = emailOrMobileNumber.replace(/[^a-zA-z0-9]/g, "");
      params.contact_number = contactNumber;
    }
    params.has_accepted_terms_and_condition = true;
    params.tnc_url = this.props.termsAndConditionsUrl;
    params.is_existing_user = true;
    this.props.signInUser(params);
  };

  onFormValidationSuccess = () => {
    this.setState({
      errors: {},
    });
    const { emailOrMobileNumber, password, otp } = this.state;
    const params = {
      password,
      code: otp,
    };
    if (emailOrMobileNumber.includes("@")) {
      params.email = emailOrMobileNumber;
    } else {
      const contactNumber = emailOrMobileNumber.replace(/[^a-zA-z0-9]/g, "");
      params.contact_number = contactNumber;
    }
    params.has_accepted_terms_and_condition = true;
    this.props.signInUser(params);
  };

  submitForm = (e) => {
    e.preventDefault();
    if (!this.state.emailOrMobileNumber.includes("@")) {
      this.validationConfig.rules.emailOrMobileNumber = this.phoneRule;
    } else {
      this.validationConfig.rules.emailOrMobileNumber = this.emailRule;
    }
    validate(
      this.validationConfig,
      this.state,
      this.onFormValidationFailure,
      this.onFormValidationSuccess
    );
  };

  componentDidMount() {}

  componentDidUpdate() {
    if (this.state.isSignedIn) {
      this.props.nextPage(LOGGED_IN_USER_PROCEDURE_VIEW);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.isSignedIn !== this.state.isSignedIn) {
      this.setState({ isSignedIn: nextProps.isSignedIn });
    }
  }

  // handleChange = (name, value) => {
  //   this.setState({ [name]: value });
  // };

  onValidationFailure = (errors) => {
    this.setState({ errors: errors });
  };

  onForgotPasswordEvent = () => {
    this.props.nextPage(FORGOT_PASSWORD_VIEW);
  };

  onNextValidationSuccess = () => {
    const params = {
      verification_code: this.state.emailOtp,
      flow_type: this.state.flowType,
      flow_id: this.state.flowId,
      email: this.state.email,
    };
    this.props.setOtpInReduxState({ emailOtp: this.state.emailOtp });
    this.props.verifyEmailOtp(params, this.props.nextPage);
    // this.props.nextPage();
  };

  render() {
    return (
      <>
        <Modal
          show={this.state.showLoginHelpModal}
          onHide={() => {
            this.setState({ showLoginHelpModal: false });
          }}
          container={document.body}
          aria-labelledby="contained-modal-title"
          className="primary-modal loginhelp-modal"
        >
           <Modal.Header closeButton closeVariant="white">
            <Modal.Title id="contained-modal-title">Contact Us</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="footer-content-container">
              <div className="text">
                Feel free to contact us via email or phone number.
              </div>
              <div className="text">
                We would be happy to address your queries.
              </div>
              <div className="phone-container">
                <i className="icon icon-font-a-contact"></i>
                <span className="phone">{Strings.SUPPORT_PHONE_NUMBER}</span>
              </div>
              <div className="email-container">
                <i className="icon icon-font-a-email"></i>
                <span className="email">{Strings.SUPPORT_EMAIL}</span>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <div className="patient-screen-content-container">
          <div className="otp-message">
            Please enter your{" "}
            <span className="login-view-header">
              Email or Mobile Number and Password.
            </span>
          </div>
          <InputTextField
            id="email"
            label="Mobile Number or Email Address"
            name="emailOrMobileNumber"
            value={this.state.emailOrMobileNumber}
            onChange={(name, value) => this.handleChange(name, value)}
            required
            error={"emailOrMobileNumber" in this.state.errors}
            errorText={
              "emailOrMobileNumber" in this.state.errors
                ? this.state.errors.emailOrMobileNumber
                : ""
            }
          />
          <Password
            id="password"
            label="Password"
            name="password"
            value={this.state.password}
            onChange={(name, value) => this.handleChange(name, value)}
            required
            error={"password" in this.state.errors}
            errorText={
              "password" in this.state.errors ? this.state.errors.password : ""
            }
          />
          <div className="forgot-password">
            <span
              role="button"
              tabIndex="0"
              className="cursor-pointer float-right no-margin procedure-login-forgot-password"
              onClick={this.onForgotPasswordEvent}
            >
              Forgot Password
            </span>
          </div>
          <div className="pushed-down-btn-container">
            <PrimaryButton
              disabled={
                !(
                  this.state.emailOrMobileNumber.length > 0 &&
                  this.state.password.length > 0
                )
              }
              onClick={this.onSubmitClick}
              text="Login"
            />
            <div
              className="login-help-text text-align-center cursor-pointer"
              onClick={() => this.setState({ showLoginHelpModal: true })}
            >
              Login Help?
            </div>
          </div>
        </div>
      </>
    );
  }
}

LoginView.propTypes = {
  isLoading: PropTypes.bool,
  firstName: PropTypes.string,
  email: PropTypes.string,
  isSignedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  firstName: state.patientRegister.firstName,
  email: state.patientRegister.email,
  phone: state.patientRegister.phone,
  zipCode: state.patientRegister.zipCode,
  page: state.patientRegister.page,
  flowType: state.patientRegister.flowType,
  flowId: state.patientRegister.flowId,
  isSignedIn:
    state.currentUser.isSignedIn || !isEmpty(getItemFromStorage("token")),
});

const mapDispatchToProps = (dispatch) => ({
  signInUser: (params) => dispatch(signInUser(params)),
  generateEmailOtp: (params, nextPage, redirect = true) =>
    dispatch(generateOtp(params, nextPage, redirect)),
  setOtpInReduxState: (params) => dispatch(setOtpInState(params)),
  generatePhoneOtp: (params, nextPage) =>
    dispatch(generateOtp(params, nextPage)),
  verifyEmailOtp: (params, nextPage) => dispatch(verifyOtp(params, nextPage)),
});
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(LoginView);
